module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r8n5n1n-ab8caedc78d4cea96f2a35f9c3ad7255.svg";